$(document).ready(function() {
  $('.collection-sorting-lists .active-filter')
    .parents('ul.collection-sorting-lists')
    .toggle()

  // if( $('.sub-sorting-list .active-filter').parents('ul.collection-sorting-lists').css('display' == 'none') ) {
  //     $('.sub-sorting-list .active-filter').parents('ul.collection-sorting-lists').prev().addClass('trigger-open');
  // }

  $('.collection-sorting-lists .active-filter')
    .parents('ul.collection-sorting-lists')
    .prev()
    .addClass('trigger-open')

  $('.sorting-trigger').on('click', function(e) {
    $(this).toggleClass('trigger-open')
    $(this)
      .next()
      .toggle()
  })

  // Cart Force Require
  var cartSubmitValidated = false
  var cartSubmited = false

  var forceCartRequire = (function() {
    if ($('body').hasClass('template-cart')) {
      var $form = $('form.cart')
      var $requiredFields = $form.find('.required')
      var $submitButton = $form.find('button[type="submit"]')

      //   IT"S WORKING, BUT WHEN IT TRIGGERS THE CLICK, IT's RUNNING AN INFINATE LOOP UNTIL THE SUBMIT ACTUALLY HAPPENS
      $submitButton.on('click', function(event) {
        if (!cartSubmitValidated) {
          event.preventDefault()
          var validated = true

          for (var i = 0; i <= $requiredFields.length; i++) {
            var $field = $($requiredFields[i])
            if ($field.length) {
              var isRadio = $field.attr('type') === 'radio'
              var fieldValidated = isRadio
                ? validateRadio($field, $form)
                : $field.val() != ''

              if (!fieldValidated) validated = false
            }
          }
          if (validated) {
            cartSubmited = true
            cartSubmitValidated = true

            if ($form.find('.form-error').remove())
              setTimeout(function() {
                $submitButton.trigger('click', function(event) {
                  cartSubmitValidated = false
                })
              }, 0)
          } else {
            $submitButton
              .closest('div')
              .append(
                '<p class="form-error">You must fill out all the required fields.</p>',
              )
          }
        }
      })
    }
  })()

  function validateRadio($field, $form) {
    var name = $field.attr('name')
    var validated = false
    var $allFieldsWithName = $form.find('input[name="' + name + '"]')

    for (var i = 0; i <= $allFieldsWithName.length; i++) {
      var $subField = $($allFieldsWithName[i])
      if ($subField.length && $subField.is(':checked')) validated = true
    }

    return validated
  }
})
